/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AccountExperienceTransactionSubject = {
    GLEAM_REWARD: 'GLEAM_REWARD',
    CANDY_BLAST: 'CANDY_BLAST',
    PIZZA_CAFE: 'PIZZA_CAFE',
    BURGER_CAFE: 'BURGER_CAFE',
    RALLY_CHAMPION: 'RALLY_CHAMPION',
    SPIN2WIN: 'SPIN2WIN',
    IN_THE_WEEDS: 'IN_THE_WEEDS',
    OTHER: 'OTHER',
    ADMIN_DEBIT: 'ADMIN_DEBIT',
    ADMIN_CREDIT: 'ADMIN_CREDIT',
    MENU_ORDER_REWARD: 'MENU_ORDER_REWARD',
    LOAD_FUEL: 'LOAD_FUEL',
    INDUSTRY_PASS_PURCHASE_REWARD: 'INDUSTRY_PASS_PURCHASE_REWARD',
    REFER_A_FRIEND_FIRST_ORDER_REWARD: 'REFER_A_FRIEND_FIRST_ORDER_REWARD',
    SIGN_UP: 'SIGN_UP',
    LEVEL_UP: 'LEVEL_UP',
    OVERWOLF_TIME_REWARD: 'OVERWOLF_TIME_REWARD',
    OVERWOLF_EVENT_REWARD: 'OVERWOLF_EVENT_REWARD',
    OVERWOLF_TIME_QUEST_REWARD: 'OVERWOLF_TIME_QUEST_REWARD',
    GUILD_EVENT_QUEST_REWARD: 'GUILD_EVENT_QUEST_REWARD',
    GUILD_TIME_QUEST_REWARD: 'GUILD_TIME_QUEST_REWARD',
    DISCORD_DAILY_XP: 'DISCORD_DAILY_XP',
    BRAND_CHALLENGE_REWARD: 'BRAND_CHALLENGE_REWARD',
    BRAND_CHALLENGE_RAFFLE_PRIZE: 'BRAND_CHALLENGE_RAFFLE_PRIZE',
    LOOTBOX_REDEEM_REWARD: 'LOOTBOX_REDEEM_REWARD',
    GUILD_SPONSORED_COMPETITION_REWARD: 'GUILD_SPONSORED_COMPETITION_REWARD',
    FUELUP_ADVENTURE_REWARD: 'FUELUP_ADVENTURE_REWARD',
    CLIP_SHARE: 'CLIP_SHARE',
    CREATOR_SHOP_PURCHASE: 'CREATOR_SHOP_PURCHASE',
    STREAK_WINDOW_REWARD: 'STREAK_WINDOW_REWARD',
    REWARD_DISTRIBUTION: 'REWARD_DISTRIBUTION',
    PROMO_TOKEN_REDEEMED: 'PROMO_TOKEN_REDEEMED',
    STREAM_WATCH_TIME_REWARD: 'STREAM_WATCH_TIME_REWARD'
} as const;
export type AccountExperienceTransactionSubject = typeof AccountExperienceTransactionSubject[keyof typeof AccountExperienceTransactionSubject];


export function instanceOfAccountExperienceTransactionSubject(value: any): boolean {
    for (const key in AccountExperienceTransactionSubject) {
        if (Object.prototype.hasOwnProperty.call(AccountExperienceTransactionSubject, key)) {
            if (AccountExperienceTransactionSubject[key as keyof typeof AccountExperienceTransactionSubject] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccountExperienceTransactionSubjectFromJSON(json: any): AccountExperienceTransactionSubject {
    return AccountExperienceTransactionSubjectFromJSONTyped(json, false);
}

export function AccountExperienceTransactionSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountExperienceTransactionSubject {
    return json as AccountExperienceTransactionSubject;
}

export function AccountExperienceTransactionSubjectToJSON(value?: AccountExperienceTransactionSubject | null): any {
    return value as any;
}

export function AccountExperienceTransactionSubjectToJSONTyped(value: any, ignoreDiscriminator: boolean): AccountExperienceTransactionSubject {
    return value as AccountExperienceTransactionSubject;
}

